import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { CriticalStandard } from '@/domain/types/collections';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const CriticalStandarsAddPage = () => {
  const navigate = useNavigate();

  const handleSave = async (data: CriticalStandard | any) => {
    try {
      await addDoc(collection(db, DOCUMENTS_DB.CRITICAL_STANDARS), {
        ...data,
        createdAt: serverTimestamp(),
      });
      toast.success('Documento guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/critical-standars');
    } catch (error) {
      toast.error('Error al guardar el documento', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Estándar Crítico</h1>
      <FormAddDocument onSave={handleSave} contentType="critical-standard" />
    </div>
  );
};

export default CriticalStandarsAddPage;
